// @ts-nocheck
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useMediaQuery,
} from "@chakra-ui/react";
import { faMultiply } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";
import useFetch from "../../../ApiClient/GetApi";
import { PostApi } from "../../../ApiClient/PostApi";
import { Loader2 } from "../../loader/Loader";
import { error_toaster, success_toaster } from "../../toaster/Toaster";
import Header from "../layout/Header";
import { BulletList, Facebook } from "react-content-loader";
import { useNavigate } from "react-router-dom";
export default function PayPalPaymentOptions() {
  const navigate = useNavigate();
  const [xl] = useMediaQuery("(min-width: 1280px)");
  const [md] = useMediaQuery("(min-width: 768px)");
  const [sm] = useMediaQuery("(min-width: 640px)");
  const [xs] = useMediaQuery("(min-width: 425px)");

  const { data } = useFetch(
    `booking/payment_detail_page/${localStorage.getItem("orderId")}`
  );

  const [loading, SetLoading] = useState(false);

  const createPaypalToken = async () => {
    SetLoading(true);
    const res = await PostApi("users/home/createPaypalToken", {});
    if (res.data.status === "1") {
      localStorage.setItem("paypal_access_token", res.data.token);
      SetLoading(false);
      navigate("/card");
    } else {
      SetLoading(false);
      error_toaster("Something went wrong!");
    }
  };

  const paypal_payment = async () => {
    SetLoading(true);
    const res = await PostApi("users/home/paypal_payment", {
      amount:
        data?.data?.serviceType === "Full Services"
          ? data?.data?.freightPrice
          : data?.data?.totalPrice,
    });

    if (res.data.status === "1") {
      SetLoading(false);
      success_toaster(res.data.message);
      res.data.data.links.map((link) => {
        if (link.rel === "approval_url") {
          localStorage.setItem("transactionId", res.data.data.id);
          window.location.href = link.href;
        }
      });
    } else {
      SetLoading(false);
      error_toaster(res.data.message);
    }
  };

  return (
    <section className="font-soehne">
      <Header />

      <section
        className="xl:w-4/5 w-11/12 bg-themeGray2 mx-auto lg:my-20 my-12 sm:py-12 py-8 sm:px-8 px-4 
              rounded-lg"
      >
        {data.length === 0 ? (
          <Loader2 />
        ) : (
          <>
            {loading ? (
              <Facebook height={160} />
            ) : (
              <div className="grid lg:grid-cols-12 gap-x-10 gap-y-12">
                <div className="lg:col-span-7 space-y-8">
                  <div className="flex items-center gap-x-3">
                    <img
                      src="images/myOrders/card.webp"
                      alt="card"
                      className="w-6"
                    />
                    <h1 className="font-medium text-2xl text-themeBlue">
                      Select Payment Method
                    </h1>
                  </div>
                  <div className="flex sm:flex-row flex-col sm:items-center gap-x-6 gap-y-4">
                    <button
                      onClick={createPaypalToken}
                      className="flex items-center gap-x-3 bg-white font-normal text-base px-8 py-5 
                  rounded-xl"
                    >
                      <img
                        src="images/myOrders/debit_card.png"
                        alt="paystack"
                        className="w-10"
                      />
                      <span>Credit/Debit Card</span>
                    </button>
                    <button
                      onClick={paypal_payment}
                      className="flex items-center gap-x-3 bg-white font-normal text-base px-8 py-5 
                  rounded-xl"
                    >
                      <img
                        src="images/myOrders/paypal.webp"
                        alt="paypal"
                        className="w-6"
                      />
                      <span>Pay with PayPal</span>
                    </button>
                  </div>
                  <div>
                    {/* <div className="grid sm:grid-cols-2 gap-x-7 gap-y-4">
                    <input
                      type="number"
                      name="cardNo"
                      placeholder="XXXX XXXX XXXX XXXX"
                      className={`${inputStyle} sm:col-span-2`}
                    />
                    <input
                      type="number"
                      name="expiry"
                      placeholder="Expiry"
                      className={inputStyle}
                    />
                    <input
                      type="number"
                      name="cvv"
                      placeholder="CVV"
                      className={inputStyle}
                    />
                  </div> */}
                  </div>
                </div>
                <div className="lg:col-span-5 sm:space-y-6 space-y-4">
                  <div className="flex lg:justify-center items-center gap-x-3">
                    <img
                      src="images/myOrders/invoice.webp"
                      alt="card"
                      className="w-6"
                    />
                    <h1 className="font-medium text-2xl text-themeBlue">
                      Invoice Details
                    </h1>
                  </div>
                  <ul className="space-y-6">
                    <li className="flex sm:flex-row flex-col justify-end sm:items-center gap-x-14">
                      <h6 className="font-medium text-base text-black text-opacity-40">
                        Insurance
                      </h6>
                      <h5 className="font-normal text-base">
                        $ {data?.data?.insurance}
                      </h5>
                    </li>
                    <li className="flex sm:flex-row flex-col justify-end sm:items-center gap-x-14">
                      <h6 className="font-medium text-base text-black text-opacity-40">
                        Freight ( kg * {data?.data?.companyTax})
                      </h6>
                      <h5 className="font-normal text-base">
                        $ {data?.data?.freighPrice}
                      </h5>
                    </li>
                    <li className="flex sm:flex-row flex-col justify-end sm:items-center gap-x-14">
                      <h6 className="font-medium text-base text-black text-opacity-40">
                        Repacking Fee
                      </h6>
                      <h5 className="font-normal text-base">
                        $ {data?.data?.repacking}
                      </h5>
                    </li>
                    <li className="flex sm:flex-row flex-col justify-end sm:items-center gap-x-14">
                      <h6 className="font-medium text-base text-black text-opacity-40">
                        Import VAT
                      </h6>
                      <h5 className="font-normal text-base">
                        $ {data?.data?.vatTax ?? ""}
                      </h5>
                    </li>
                    <li className="flex sm:flex-row flex-col justify-end sm:items-center gap-x-14">
                      <h6 className="font-medium text-base text-black text-opacity-40">
                        Import Duties
                      </h6>
                      <h5 className="font-normal text-base">
                        $ {data?.data?.importDuty ?? ""}
                      </h5>
                    </li>
                    <li className="flex sm:flex-row flex-col justify-end sm:items-center gap-x-14">
                      <h6 className="font-medium text-base text-black text-opacity-40">
                        Customs Clearance Fee
                      </h6>
                      <h5 className="font-normal text-base">
                        $ {data?.data?.customerClearanceFee ?? ""}
                      </h5>
                    </li>
                  </ul>
                  <h1 className="font-medium sm:text-4xl text-2xl text-end">
                    Total Price : $ {data?.data?.totalPrice ?? ""}
                  </h1>
                  <h1 className="font-medium sm:text-4xl text-2xl text-end">
                    {data?.data?.serviceType === "Full Services" ? (
                      <div>
                        {" "}
                        <span className="text-sm font-normal mx-4">
                          For Full Services only to pay( Freight + Insurance)
                        </span>
                        <br />$ {data?.data?.freightPrice}
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </h1>
                  {/* <div className="flex justify-end">
                <button
                  onClick={openModal}
                  className="font-bold sm:text-xl text-base text-white bg-themeBlue px-6 py-3 rounded-md
                  border border-themeBlue hover:bg-transparent hover:text-themeBlue"
                >
                  Secure Pay
                </button>
              </div> */}
                </div>
              </div>
            )}
          </>
        )}
      </section>
    </section>
  );
}
